// NATIVE

// INSTALLED

// CUSTOM
import { AxiosAdapter } from '../commons/adapters';

const http = new AxiosAdapter();

export const getEmployesService = async (status: number = 1) => {
  try {
    return await http.get<any>(`/v1/employes?status=${status}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getEmployesService ', error);
  }
};

export const getEmployesDataCreateService = async () => {
  try {
    return await http.get<any>('/v1/employes/data-create-form-inputs');
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getEmployesService ', error);
  }
};

export const getEmployesByPaginateService = async (page: number, status: number = 1) => {
  try {
    return await http.get<any>(`/v1/employes?page=${page}&take=10&status=${status}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getEmployesByPaginateService ', error);
  }
};

export const saveEmployeeService = async (employee: object, setPercentajeCCompany: any) => {
  try {
    return await http.post<any>('/v1/employes', employee, setPercentajeCCompany);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('saveEmployeeService ', error);
  }
};

export const createMassiveEmployeeService = async (file: File) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    return await http.post<any>('/v1/employes/create-maxive', formData, () => {});
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('createMassiveEmployeeService ', error);
  }
};

export const updateEmployeeService = async (employee: object, setPercentajeCCompany?: any) => {
  try {
    return await http.put<any>('/v1/employes', employee);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('saveEmployeeService ', error);
  }
};

export const getEmployesBySearchService = async (param: string, status: number = 1) => {
  try {
    const query = status !== undefined ? `&status=${status}` : '';
    return await http.get<any>(`/v1/employes?page=1&take=10&param=${param}${query}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getEmployesBySearchService ', error);
  }
};

export const desactiveEmployeService = async (
  employeId: string,
  value: string,
  pagePagination: number = 1,
  take: number = 10,
  status: number = 1
) => {
  try {
    return await http.deleteTable<any>(`/v1/employes/${employeId}`, {
      param: value,
      page: pagePagination,
      take,
      status,
    });
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('desactiveEmployeService ', error);
  }
};

export const activeEmployeService = async (
  employeId: string,
  value: string,
  pagePagination: number = 1,
  take: number = 10,
  status: number = 1
) => {
  try {
    return await http.patchTable<any>(`/v1/employes/${employeId}/restore`, {
      status,
    });
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('activeEmployeService ', error);
  }
};

export const getEmployeeDetailService = async (employeeId: string) => {
  try {
    return await http.get<any>(`/v1/employes/${employeeId}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getEmployeeDetailService ', error);
  }
};

export const getEmployeeDetailEditService = async (employeeId: string) => {
  try {
    return await http.get<any>(`/v1/employes/data-edit-form-inputs/${employeeId}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getEmployeeDetailEditService ', error);
  }
};

// getEmployesBySearchService

export const verifyEmailService = async (email: string) => {
  try {
    return await http.post<any>('/v1/employes/verified-email', { email }, () => {});
  } catch (error: any) {
    console.log('verifyEmailService ', error);
    if (error && !error.ok) {
      return error;
    }
  }
};

export const entregarDotacionesService = async (dotacionIds: string[]) => {
  try {
    return await http.post<any>('/v1/dotaciones/entregar', { dotacionIds }, () => {});
  } catch (error: any) {
    console.log('entregarDotacionesService ', error);
    if (error && !error.ok) {
      return error;
    }
  }
};

export const downloadActaPdfService = async (actaId: string) => {
  try {
    return await http.getImages<any>(`/v1/dotaciones/pdf/${actaId}`);
  } catch (error: any) {
    console.log('downloadActaPdfService ', error);
  }
};

export const downloadContractPdfService = async (employeeId: string) => {
  try {
    return await http.getImages<any>(`/v1/employes/${employeeId}/contract-pdf`);
  } catch (error: any) {
    console.log('downloadContractPdfService ', error);
  }
};

export const downloadPdfEmployeeService = async (filename: string) => {
  try {
    return await http.getImages<any>(`/v1/files/pdf-employee/${filename}`);
  } catch (error: any) {
    console.log('downloadPdfEmployeeService ', error);
  }
};
